import { useMemo } from 'react'
import { styled, Typography, useTheme, ButtonBase } from '@mui/material'
import { getWappTheme } from '$common/wapp-bar-theme'
import { useWapp } from '$logic/wapps/react-hook'
import { getWappIcon } from '$logic/wapps/wapps.helper'
import { WappPanel } from '$logic/wapp-panels'

const Container = styled(ButtonBase)`
  display: flex;
  align-items: center;
  width: 280px;

  padding: 8px 10px;
  border-radius: 12px;
  gap: 10px;

  box-sizing: border-box;
  overflow: hidden;

  & span {
    width: fit-content;
  }
`

const WappIconContainer = styled('div')`
  width: 48px;
  height: 48px;
  border-radius: 16px 16px 16px 0;
  overflow: hidden;

  & img,
  & svg {
    width: 100%;
    height: 100%;
  }
`

const InfoContainer = styled('div')`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 5px;
`

interface PropTypes {
  wappId: string
  wisId?: string
  fromMe: boolean
}
export function NonInlineWapp({ wappId, wisId, fromMe }: PropTypes) {
  const { entity: wapp, loading } = useWapp(wappId) || {}
  const wappName = wapp?.groupName

  const { name: nameInTheme, icon: iconInTheme } = getWappTheme(wappId)

  const wappIcon = useMemo(
    () => iconInTheme || <img src={getWappIcon(wappId)} alt="Wapp Icon" />,
    [wappId, iconInTheme],
  )

  const theme = useTheme()

  return (
    <Container
      onClick={() => WappPanel.openWapp({ wappId, wisId })}
      sx={{
        background: fromMe
          ? theme.palette.lightChatSenderGradient
          : theme.palette.neutral000,
      }}
    >
      <WappIconContainer>{wappIcon}</WappIconContainer>

      {loading ? null : (
        <InfoContainer>
          <Typography
            variant="subtitle4"
            color={fromMe ? 'neutral000' : 'neutral900'}
          >
            {iconInTheme ? nameInTheme : wappName}
          </Typography>

          <Typography
            variant="caption1"
            color={fromMe ? 'neutral200' : 'neutral600'}
          >
            ابزار
          </Typography>
        </InfoContainer>
      )}
    </Container>
  )
}
